import Vue from 'vue';
import App from './App.vue';

import './common/all.css';

import axios from 'axios';
import router from "./router.js";
import store from './store.js';

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);

import Video from 'video.js' 
import 'video.js/dist/video-js.css'
 Vue.prototype.$video = Video;

import './icons';
import '@/permission';
import echarts from "echarts";
import Print from "vue-print-nb";
Vue.use(Print);
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

//全局注册，使用方法为:this.$axios
Vue.prototype.$axios = axios;
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '8HqFySu9TNbYj1v8yr0CgOF69UmzXnxp'
})

//release
Vue.prototype.$institutionUrl = "http://insapi.ltylao.com:9985/";
Vue.prototype.$imgUrl = "http://insimg.ltylao.com/";
Vue.prototype.$deviceUrl = "http://deviceapi.ltylao.com:50001/";
Vue.prototype.$signKey = "ED139FA9132F1E60967C8579D1F7B958";



new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
